import * as React from 'react';

var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  viewBox: "14 14 16 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a_45E6DT4F{fill:transparent}.b_45E6DT4F{fill:none}"))), /*#__PURE__*/React.createElement("path", {
  d: "M4.8 6A1.2 1.2 0 1 1 6 4.8 1.2 1.2 0 0 1 4.8 6m12.728 3.664-7.2-7.2A1.59 1.59 0 0 0 9.2 2H3.6A1.594 1.594 0 0 0 2 3.6v5.6a1.564 1.564 0 0 0 .472 1.128l7.192 7.2A1.63 1.63 0 0 0 10.8 18a1.6 1.6 0 0 0 1.128-.472l5.6-5.6A1.564 1.564 0 0 0 18 10.8a1.6 1.6 0 0 0-.472-1.136Z",
  transform: "translate(12 12)",
  style: {
    fill: "currentColor"
  }
}));

export { SvgTag as default };
